import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { EBasketCardEventStatusKey } from 'og-web-core/utils/basket/basket.types'
import { basketCardEventStatusTestData } from 'og-web-core/utils/test-data/constants'
import {
  EFeatureFlags,
  useFeatureFlag
} from 'astra-core/containers/ConfigProvider'

import { ETestData } from 'shared/lib/testData'

import { LoaderEventPending } from '../../Common'

import { BasketCardEventStatusProps } from './BasketCardEventStatus.types'
import {
  StyledBetCardEventPending,
  StyledBetCardEventStatus
} from './BasketCardEventStatus.styled'

export const BasketCardEventStatus: FC<BasketCardEventStatusProps> = (
  props
) => {
  const { status, restriction, rejected } = props
  const { t } = useTranslation()

  const isEventExclusionEnabled = useFeatureFlag(
    EFeatureFlags.EVENTS_EXCLUSION_ENABLED
  )
  const isOnlyOrdinarEnabled = useFeatureFlag(
    EFeatureFlags.ONLY_ORDINAR_ENABLED
  )

  if (rejected) {
    return (
      <StyledBetCardEventStatus>
        {t('bet is unavailable')}
      </StyledBetCardEventStatus>
    )
  }

  if (restriction) {
    if (isEventExclusionEnabled && restriction === 'excluded') {
      return (
        <StyledBetCardEventStatus>
          {t('event is unavailable')}
        </StyledBetCardEventStatus>
      )
    }
    if (isOnlyOrdinarEnabled && restriction === 'onlyOrdinar') {
      return (
        <StyledBetCardEventStatus>{t('only ordinar')}</StyledBetCardEventStatus>
      )
    }
  }

  switch (status) {
    case EBasketCardEventStatusKey.LOADING: {
      return (
        <StyledBetCardEventPending>
          <LoaderEventPending testData={ETestData.TestLoaderEventPending} />
        </StyledBetCardEventPending>
      )
    }

    case EBasketCardEventStatusKey.EVENT_CANCELED:
    case EBasketCardEventStatusKey.EVENT_POSTPONED:
    case EBasketCardEventStatusKey.EVENT_INTERRUPTED:
    case EBasketCardEventStatusKey.OUTCOME_NOT_AVAILABLE:
    case EBasketCardEventStatusKey.EVENT_ENDED:
    case EBasketCardEventStatusKey.EVENT_SUSPENDED: {
      return (
        <StyledBetCardEventStatus
          data-test-id={basketCardEventStatusTestData[status]}
        >
          {t(status)}
        </StyledBetCardEventStatus>
      )
    }

    default: {
      return null
    }
  }
}
